<template>
  <v-alert no-gutters class="c-custom--v-alert c-result-top-infos__col--gray c-result-top-infos__col--radius c-custom--h-100 result-walking mb-0">
    <div v-if="isMobile">
      <div class="font-weight-bold">
        ウォーキングラリー中部の旅
      </div>
      <h3 class="c-result-title-size d-flex mb-3 font-weight-bold">
        <span v-if="this.currentPointSequence === 1">{{this.currentPoint}}からスタート！</span>
        <span v-else>{{this.currentPoint}} に到着！</span>
      </h3>
    </div>
    <v-row
      no-gutters
      class="d-md-flex d-block flex-md-row-reverse align-center c-custom--h-100"
    >
      <v-col
        cols="12" sm="12" md="5"
        align-self="center"
        class="d-flex justify-center"
      >
        <div style="pointer-events: none; width: 210px; padding: 0 !important;">
          <ChubuMap
            :arrivedPointIdList="arrivedPointIdList"
            :isSecondGoalEnabled="isSecondGoalEnabled"
          />
        </div>
      </v-col>
      <v-col
        cols="12"
        sm=""
        class=""
      >
        <div v-if="!isMobile">
          <div class="font-weight-bold">
            ウォーキングラリー中部の旅
          </div>
          <h3 class="c-result-title-size d-flex mb-4 font-weight-bold">
            <span v-if="this.currentPointSequence === 1">{{this.currentPoint}}からスタート！</span>
            <span v-else>{{this.currentPoint}} に到着！</span>
          </h3>
        </div>
        <table class="result-walking__table font-weight-bold">
          <tr>
            <th class="px-0 text-center">あなたの累計歩数</th>
            <td class="px-0 text-center">{{this.numberOfSteps.toLocaleString()}}歩</td>
          </tr>
          <tr>
            <th class="px-0 text-center">あなたの推定移動距離</th>
            <td class="px-0 text-center">{{Math.floor(this.numberOfSteps * this.strideLength * 10) / 10}}km</td>
          </tr>
          <tr>
            <th class="px-0 text-center">この地点を通過した人数</th>
            <td class="px-0 text-center">{{this.walkingRank.toLocaleString()}}<template v-if="walkingRank !== '未計算'">人</template></td>
          </tr>
        </table>
        <div class="result-walking__btn pt-6">
          <v-btn
            @click="walkingDialog = true"
            rounded
            x-large
            elevation="0"
            class="c-result-btn--gray c-custom--w-100 font-weight-bold text-center"
          >
            <span>詳細はこちら</span>
          </v-btn>
        </div>
      </v-col>
    </v-row>
    <v-dialog
      v-model="walkingDialog"
      scrollable
      :max-width="1200"
      class="c-custom--v-dialog"
    >
      <v-card>
        <v-btn
          fab
          small
          elevation="0"
          @click="walkingDialog = false"
          class="c-result-dialog-close-btn"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-card-text>
          <WalkingTravelDetail
            :walkingTravelPointList="walkingTravelPointList"
            :numberOfSteps="numberOfSteps"
            :strideLength="strideLength"
            :arrivedPointIdList="arrivedPointIdList"
            :currentPoint="currentPoint"
            :currentPointSequence="currentPointSequence"
            :firstGoalSequence="firstGoalSequence"
            :isSecondGoalEnabled="isSecondGoalEnabled"
            :walkingDialog="walkingDialog"
            @setFirstGoalAchievedPopUp="setFirstGoalAchievedPopUp"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
    <div class="text-center">
      <v-dialog
        v-model="firstGoalAchievedPopUp"
        width="500"
      >
        <v-card class="higher-z-index">
          <v-card-title class="text-h5 grey lighten-2">
            第一ゴール達成！おめでとう！
          </v-card-title>

          <v-card-text style="padding-top: 10px !important;">
            「まだまだ歩き足りないあなた」に新たな挑戦状が届きました！
            引き続き楽しくウォーキングを続けましょう！
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              text
              @click="enableSecondGoal()"
            >
              第二ゴールを目指す
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </v-alert>
</template>

<script>
import GraphqlAPI from '../../utils/GraphqlAPI'
const ChubuMap = () => import('./ChubuMap')
const WalkingTravelDetail = () => import('./WalkingTravelDetail')

const listWalkingTravelPointQuery = (campaignId) => `
  query getListWalkingTravelPointQuery {
    listWalkingTravelPoint(campaign_id: "${campaignId}") {
      walking_travel_points {
        id
        point_name
        specialty
        sequence
        distance
        point_image_path
        point_detail
        point_streetView_url
      }
    }
  }
`
const getListWalkingTravelPointQuery = async (campaignId) => {
  const { data: { listWalkingTravelPoint: data } } = await GraphqlAPI(listWalkingTravelPointQuery(campaignId))
  return data
}

const getWalkingTravelUserDetailQueryString = (campaignId) => `
  query getWalkingTravelUserDetailQuery {
    getWalkingTravelUserDetail(campaign_id: "${campaignId}") {
      id
      meta
      is_second_goal_enabled
    }
  }
`
const createWalkingTravelUserDetailMutationString = (campaignId, isSecondGoalEnabled) => `
  mutation MyMutation {
    createWalkingTravelUserDetail(campaign_id: "${campaignId}", is_second_goal_enabled: ${isSecondGoalEnabled}) {
      id
      is_second_goal_enabled
      meta
    }
  }
`

export default {
  name: 'walkingTravel',
  data () {
    return {
      walkingTravelPointList: [],
      currentPoint: '',
      currentPointSequence: null,
      strideLength: 0.0007,
      arrivedPointIdList: [],
      walkingDialog: false,
      isSecondGoalEnabled: false,
      firstGoalAchievedPopUp: false
    }
  },
  props: [
    'numberOfSteps',
    'firstGoalSequence',
    'walkingRank'
  ],
  components: {
    ChubuMap,
    WalkingTravelDetail
  },
  computed: {
    campaign () {
      return this.$store.getters.getCampaign
    },
    isMobile () { // モバイル判定
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return true
        case 'sm': return true
        case 'md': return false
        case 'lg': return false
        case 'xl': return false
      }
      return false
    }
  },
  watch: {
    numberOfSteps: {
      handler (newValue) {
        this.arrivedPointIdList = []
        for (const point of this.walkingTravelPointList) {
          if (point.distance !== null) {
            if (point.distance <= newValue * this.strideLength) {
              this.currentPoint = point.point_name
              this.currentPointSequence = point.sequence
              this.arrivedPointIdList.push(point.sequence)
            } else {
              break
            }
          }
        }
        this.keepFirstGoalIsNotSecondGoalEnabled()
      }
    }
  },
  async created () {
    const result = await getListWalkingTravelPointQuery(this.campaign.id)
    this.walkingTravelPointList = result.walking_travel_points.sort(function (a, b) {
      return (a.sequence < b.sequence) ? -1 : 1
    })
    this.calcCurrentPoint()
    // 1つ目のゴールを設定していたら（2つ目のゴールがある）、2つ目のゴールが有効になっているか取得してセットする
    if (this.firstGoalSequence) {
      const walkingTravelUserDetail = await this.getWalkingTravelUserDetailQuery(this.$store.getters.getCampaign.id)
      if (walkingTravelUserDetail) {
        this.isSecondGoalEnabled = walkingTravelUserDetail.is_second_goal_enabled
      }
      this.keepFirstGoalIsNotSecondGoalEnabled()
    }
  },
  methods: {
    async getWalkingTravelUserDetailQuery (campaignId) {
      const { data: { getWalkingTravelUserDetail: res } } = await GraphqlAPI(getWalkingTravelUserDetailQueryString(campaignId))
      return res
    },
    setFirstGoalAchievedPopUp (v) {
      this.firstGoalAchievedPopUp = v
    },
    async enableSecondGoal () {
      const { data: { createWalkingTravelUserDetail: res1 } } = await GraphqlAPI(createWalkingTravelUserDetailMutationString(this.campaign.id, true))
      await GraphqlAPI(createWalkingTravelUserDetailMutationString(this.campaign.relational_campaign_id, true))
      this.isSecondGoalEnabled = res1.is_second_goal_enabled
      this.calcCurrentPoint()
      this.firstGoalAchievedPopUp = false
      return res1
    },
    calcCurrentPoint () {
      for (const point of this.walkingTravelPointList) {
        if (point.distance !== null) {
          if (point.distance <= this.numberOfSteps * this.strideLength) {
            this.currentPoint = point.point_name
            this.currentPointSequence = point.sequence
            this.arrivedPointIdList.push(point.sequence)
          } else {
            break
          }
        }
      }
    },
    keepFirstGoalIsNotSecondGoalEnabled () {
      if (!this.isSecondGoalEnabled && (this.firstGoalSequence < this.currentPointSequence)) {
        this.currentPointSequence = this.firstGoalSequence
        this.currentPoint = this.walkingTravelPointList[this.currentPointSequence - 1].point_name
      }
    }
  }
}
</script>
<style scoped lang="scss">
.result-walking {
  font-size: 15px;
}
.result-walking__btn {
  width: min(60%, 180px);
  margin: 0 auto;
  @media screen and (min-width: 960px) {
    width: 144px;
    margin: 0 auto 0 0;
  }
}
.result-walking__table {
  table-layout: auto;
  width: 100%;
  border-collapse: collapse;
  tr {
    &:nth-child(n) {
      border-bottom: 1px solid #fff;
    }
  }
  th, td {
    padding: 5px 10px;
  }
  th {
    width: 60%;
    background-color: #FFE34F;
  }
  td {
    width: 40%;
    font-size: 20px;
    background-color: #FFFDE1;
  }
}

/* 初期 */
.walking_travel_tabel {
  table-layout: auto;
  width: 100%;
  border-collapse: collapse;
  font-size: 0.75rem !important;
  th, td {
    padding: 5px 10px;
    border: 1px solid #ccc;
  }
  th {
    background-color: #FFF8E1;
  }
}
.custom-w--100 { width: 100%;}
.custom-color--info {
  color: #63A7FF !important;
}
</style>
